module.exports = __webpack_public_path__ + "app-static/img/04.1108a5e4.jpg";